import React, {useEffect, useState} from "react";
import "./CardCommande.scss";
import {useNavigate} from "react-router-dom";
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBoxOpen, faTruck, faCheckCircle, faTimesCircle, faArrowRight, faUndo} from "@fortawesome/free-solid-svg-icons";

function CardCommande({idCommande, date, prixTotal, contenuCommande, status}) {
    const dateOnly = date.substring(0, 10);

    function inverserFormatDate(date) {
        if(!date) return "";
        const [annee, mois, jour] = date.split('-');
        return `${jour}-${mois}-${annee}`;
    }

    const navigate = useNavigate();
    const tableauObjet = Object.values(contenuCommande);

    const handleClickDetails = () => {
        navigate("/profil/commandes/" + idCommande, {
            state: {
                contenuCommande: tableauObjet,
            },
        });
    };

    let statusClass = "status-default";
    let statusIcon = faBoxOpen;
    
    if (status === "Annulé" || status === "Demande de retour refusée" || status === "Non remboursée") {
        statusClass = "status-danger";
        statusIcon = faTimesCircle;
    } else if (status === "En cours de livraison") {
        statusClass = "status-warning";
        statusIcon = faTruck;
    } else if (status === "Livré" || status === "Remboursée" || status === "Demande de retour acceptée") {
        statusClass = "status-success";
        statusIcon = faCheckCircle;
    } else if (status === "En cours de préparation") {
        statusClass = "status-primary";
        statusIcon = faBoxOpen;
    } else if (status.includes("Demande de retour")) {
        statusClass = "status-warning";
        statusIcon = faUndo;
    }

    return (
        <div className="client-order-card" onClick={handleClickDetails}>
            <div className="order-card-header">
                <div className="order-id-date">
                    <span className="order-id">Commande N°{idCommande}</span>
                    <span className="order-date">Passée le {inverserFormatDate(dateOnly)}</span>
                </div>
                <div className={`order-status-badge ${statusClass}`}>
                    <FontAwesomeIcon icon={statusIcon} />
                    <span>{status}</span>
                </div>
            </div>
            
            <div className="order-card-body">
                <div className="order-products-preview">
                    {tableauObjet.slice(0, 3).map((prod, idx) => (
                        <div key={idx} className="product-img-wrapper" style={{ zIndex: 3 - idx }}>
                            <img src={prod.cover} alt={prod.name || "Produit"} />
                        </div>
                    ))}
                    {tableauObjet.length > 3 && (
                        <div className="product-img-more">
                            +{tableauObjet.length - 3}
                        </div>
                    )}
                </div>
                <div className="order-info-summary">
                    <p className="order-price">{prixTotal.toFixed(2)} €</p>
                    <p className="order-items-count">{tableauObjet.length} article{tableauObjet.length > 1 ? 's' : ''}</p>
                </div>
                <div className="order-card-action">
                    <button className="btn-view-details" onClick={(e) => { e.stopPropagation(); handleClickDetails(); }}>
                        Détails <FontAwesomeIcon icon={faArrowRight} style={{marginLeft: "0.5rem"}}/>
                    </button>
                </div>
            </div>
        </div>
    );
}

CardCommande.propTypes = {
    idCommande: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    prixTotal: PropTypes.number.isRequired,
    contenuCommande: PropTypes.object.isRequired,
    status: PropTypes.string.isRequired,
};

export default CardCommande;
